// The observer's wall display shared by both Killer games (Killer and
// Cricket-style Killer): a "now throwing" banner over one row per player,
// styled by the .obs-killer rules in styles.css. The two games only differ in
// their rules, so each controller works out the rule-specific pieces - who
// the active player can hit and what each row's note says - and passes them
// in; the markup lives here so both stay identical.

export function escapeHTML(text) {
    return String(text).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}

// Returns { html, classes } - the caller sets the board's innerHTML and
// toggles the density classes on the .obs-killer element itself.
//   players, state       state[player] = { number, eliminated }
//   activeIndex          whose turn it is
//   matchComplete        the match is over (no active player any more)
//   title, subtitle      the header (the game's name, then its settings)
//   isKiller(player)     whether that player is currently a Killer
//   numberLabel(number)  the number as printed on the badge
//   targetLabels         what the active player should aim at (already
//                        formatted), and targetsHeading the banner label
//   dartLabels           this turn's darts (or the last turn's), formatted
//   noteFor(player)      the per-row note, as HTML
//   livesHTML(player)    the row's life pips, as HTML
export function killerObserverBoard({
    players, state, activeIndex, matchComplete, title, subtitle, isKiller, numberLabel,
    targetsHeading, targetLabels, dartLabels, noteFor, livesHTML
}) {
    const n = players.length;
    const accentOf = i => `--accent:var(--player-${(i % 5) + 1})`;
    const active = players[activeIndex];

    let banner;
    if (matchComplete) {
        const winner = players.find(p => !state[p].eliminated);
        const winnerIndex = players.indexOf(winner);
        banner = `
            <div>
                <div class="obs-banner-label">Game over</div>
                <div class="obs-banner-big"${winner ? ` style="${accentOf(winnerIndex)};color:var(--accent)"` : ''}>${winner ? `${escapeHTML(winner)} wins` : 'No winner'}</div>
            </div>`;
    } else {
        const size = targetLabels.length <= 1 ? 'n1' : targetLabels.length <= 3 ? 'n3' : 'n5';
        banner = `
            <div class="obs-banner-challenge" style="${accentOf(activeIndex)}">
                <div class="obs-banner-label">Now throwing</div>
                <div class="obs-banner-big" style="color:var(--accent)">${escapeHTML(active)}</div>
                <div class="obs-kdarts">${dartLabels.map(label => `<span class="obs-kdart">${label}</span>`).join('')}</div>
            </div>
            <div class="obs-kkill ${size}">
                <div class="obs-banner-label">${targetsHeading}</div>
                <div class="obs-kkill-list">${targetLabels.join(' &middot; ')}</div>
            </div>`;
    }

    const rows = players.map((player, i) => {
        const p = state[player];
        const isTurn = i === activeIndex && !matchComplete;
        const winner = matchComplete && !p.eliminated;
        const status = p.eliminated ? ['out', 'Out'] : winner ? ['killer', 'Winner'] : isKiller(player) ? ['killer', 'Killer'] : ['building', 'Building'];
        return `
            <div class="obs-krow${isTurn ? ' active' : ''}${p.eliminated ? ' out' : ''}" style="${accentOf(i)}">
                <div class="obs-knum${isKiller(player) ? ' killer' : ''}">${numberLabel(p.number)}</div>
                <div class="obs-kname">${escapeHTML(player)}</div>
                <div class="obs-ktag ${status[0]}">${status[1]}</div>
                <div class="obs-klives">${livesHTML(player)}</div>
                <div class="obs-knote">${matchComplete ? '' : noteFor(player)}</div>
            </div>`;
    }).join('');

    return {
        classes: { 'obs-kn2': n <= 2, 'obs-kdense': n > 4 },
        html: `
            <div class="obs-head"><span>${escapeHTML(title)} <span class="obs-sub">&middot; ${subtitle}</span></span></div>
            <div class="obs-banner">${banner}</div>
            <div class="obs-krows">${rows}</div>`
    };
}
